<div class="d-flex justify-content-around m-2">
    <div class="date-div">
        <label class="form-label"  for="fromDate">From:</label>
        <input [max]="disabledDates" id="fromDate" type="date" class="form-control form-control-sm" [(ngModel)]="startDate" (change)="handleSelectedCustomDate()"/>
        <label for="toDate"  class="form-label">To: </label>
        <input [min]="minDate" [max]="disabledDates" type="date" id="toDate" class="form-control form-control-sm" [(ngModel)]="endDate" (change)="handleSelectedCustomDate()"/>
    </div>
</div>